module.exports = __webpack_public_path__ + "static/media/familia_nina.3fc19ac2.png";